export const defaultColors = ["#2F855A", "#ED8936", "#C53030"];